import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { fetchAuthSession } from "@/api-queries/auth";
import { CompanyInvitationsPanel } from "@/components/client/CompanyInvitationsPanel";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async ({ context }) => {
    const session = await fetchAuthSession();
    if (!session?.user) throw redirect({ to: "/login" });
    return { session };
  },
  component: DashboardRoute,
});

function DashboardRoute() {
  const { session } = Route.useRouteContext();
  return (
    <DashboardLayout>
      <CompanyInvitationsPanel key={session.user.id} userId={session.user.id} />
      <Outlet />
    </DashboardLayout>
  );
}
